/**
 * AI Assistant prompts are defined in the frontend rather than backend to allow for:
 * - Easier customization of prompts based on UI context and user interactions
 * - Dynamic prompt generation using runtime data/state
 * - Faster iterations on prompts without backend deployments
 */

export const serviceResearchPrompt = (
  lineItem: string,
  businessModel: string,
  invoiceText: string,
  language = "German",
) => ({
  system: "",
  human: `
    You are tasked with supporting a third party accountant with no industry knowledge by interpreting what specifically was bought in an invoice.

    You will be given:

    You are tasked with supporting a third party accountant with no industry knowledge by interpreting what specifically was bought in an invoice.

    You will be given:

      - The **invoice line item** to interpret.
      - The **name of the invoice supplier**
      - The **full invoice text**
      - The **business model of the buyer.**

    Thought process:

      - Carefully read the line item and the invoice.
      - Consider if the buyer's business model adds any additional context to the likely nature of the purchase.
      - Look for clues in the invoice that could explain what the line item represents.
      - Then respond as detailed below.

    Response instructions:

      - Respond with 2 bullet points:
      - Bullet 1: What it is. Start the bullet with "Was:"
      - Bullet 2: What specifically it may be used for by a supplier with this business model. Start the bullet with "Wofür:"
      - Respond in native ${language}.
      - You must not use the name of the line item, the user already knows it.
      - Length -- Use ca 20 words per bullet point.
      - Plain English -- You’re explaining to someone with zero background in the field. Avoid industry jargon and specialized terms. If it’s a technical or industry-specific service or good, use your own knowledge to infer what the line item actually is. Avoid technical terms. Instead of "Solenoid valve", write "electronic switch that controls the flow of air or liquid in the machine".
      - Jargon clarifications -- If you have to use technical terms, define them in plain english in 2-3 words in parentheses. For instance, instead of "AMD Ryzen Prozessor und SSD", write "AMD Ryzen Prozessor (leistungsstarker Prozessor) und SSD (Speicher für schnellen Datenzugriff)".
      - Conservative approach -- For both bullet 1 and bullet 2, you must convey an appropriate amount of confidence in your answer based on the evidence at hand. If you are unsure, do not guess. For your interpretation of how the item is most likely used in the client’s business, you must use phrases that indicate that your answer is not fully certain, like “most likely” or “probably”.
      - Power-packed phrases -- Every word must earn its place. Trim filler. Drop articles and conjunctions where possible. Think in headlines, not sentences. The goal: clarity with minimal words. Your user prefers speed over formality. Each word must drive value, even if grammar takes a back seat. You're briefing an executive with very little time.

      The line item: [${lineItem}]

      The business model of the buyer: [${businessModel}]

      The invoice: [${invoiceText}]
    `
    .replace(/\{/g, "")
    .replace(/\}/g, ""),
});
